<template>
	<div class="contact-container">
		<section class="contact-section">
			<h1 class="main-title">{{ $t('aboutUS.title') }}</h1>

			<div class="contact-grid">
				<!-- Contact Information -->
				<div class="contact-info">
					<h2 class="section-title">{{ $t('contactInfo.ourContact') }}</h2>

					<div class="info-card">
						<div class="info-icon">
							<svg viewBox="0 0 24 24">
								<path fill="currentColor"
									d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
							</svg>
						</div>
						<div class="info-content">
							<h3>{{ $t('contactInfo.address') }}</h3>
							<p>{{ $t('contactInfo.companyAddress') }}</p>
						</div>
					</div>

					<div class="info-card">
						<div class="info-icon">
							<svg viewBox="0 0 24 24">
								<path fill="currentColor"
									d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
							</svg>
						</div>
						<div class="info-content">
							<h3>{{ $t('contactInfo.phone') }}</h3>
							<p>{{ $t('contactInfo.businessPhone') }}: <a href="#">134 0103 8003</a></p>
						</div>
					</div>

					<div class="info-card">
						<div class="info-icon">
							<svg viewBox="0 0 24 24">
								<path fill="currentColor"
									d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
							</svg>
						</div>
						<div class="info-content">
							<h3>{{ $t('contactInfo.email') }}</h3>
							<p>{{ $t('contactInfo.businessEmail') }}: <a href="mailto:liuqian@fst.net.cn">liuqian@fst.net.cn</a></p>
						</div>
					</div>

					<!-- <div class="social-media">
						<h3>{{ $t('contactInfo.followUs') }}</h3>
						<div class="social-icons">
							<div class="social-icon-wrapper">
								<a href="#" class="social-icon tiktok-icon" aria-label="微信小程序">
									<svg class="tiktok-svg mini-program-icon" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg">
										<g stroke="green" stroke-width="2" fill="green" fill-rule="evenodd">
											<g fill="green" fill-rule="nonzero">
												<path
													d="M49,9 C45.693,9 42.614,9.879 40,11.374 C35.205,14.118 32,18.968 32,24.5 L32,47.5 C32,51.642 27.97,55 23,55 C18.029,55 14,51.642 14,47.5 C14,44.552 16.046,42.009 19.015,40.783 C19.229,40.695 19.446,40.611 19.669,40.537 C21.538,39.787 23.141,38.379 23.736,36.744 C24.615,34.33 22.979,32.374 20.083,32.374 C19.361,32.374 18.629,32.496 17.923,32.716 C17.92,32.717 17.917,32.718 17.913,32.719 C13.726,33.921 10.231,36.557 8.133,40 C6.778,42.225 6,44.78 6,47.5 C6,56.047 13.626,63 23,63 C26.307,63 29.386,62.121 32,60.626 C36.795,57.882 40,53.032 40,47.5 L40,24.5 C40,20.358 44.029,17 49,17 C53.97,17 58,20.358 58,24.5 C58,27.574 55.781,30.216 52.604,31.374 C50.555,32.061 48.876,33.544 48.236,35.301 C47.362,37.703 48.99,39.651 51.873,39.651 C52.526,39.651 53.186,39.539 53.829,39.357 C53.934,39.328 54.038,39.296 54.142,39.265 C58.304,38.056 61.778,35.428 63.866,32 C65.222,29.776 66,27.22 66,24.5 C66,15.953 58.374,9 49,9" />
											</g>
										</g>
									</svg>
								</a>
								<div class="qr-popup">
									<div class="phone-mockup">
										<div class="phone-screen">
											<div class="app-header">
												<div class="app-icon">
													<img src="@/assets/images/gzh.jpg" alt="泛思特公众号">
												</div>
												<div class="app-name">泛思特公众号</div>
											</div>
											<div class="qr-code">
												<img src="@/assets/images/gzhewm.jpg" alt="">
											</div>
											<div class="hint-text">扫一扫关注泛思特公众号</div>
										</div>
									</div>
								</div>
							</div>
							<a href="https://www.douyin.com/user/MS4wLjABAAAAxD3qTDDJc_RIUMY9-OcAad7l1MXK3WjXe3qZ8ceHf8E?from_tab_name=main&relation=2&vid=6969768641470516515"
								class="social-icon tiktok-icon" aria-label="抖音" target="_blank" rel="noopener noreferrer">
								<svg class="tiktok-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
								</svg>
							</a>
							<a href="https://www.xiaohongshu.com/user/profile/62cbec990000000002003b85?xsec_token=ABQB8pO48dIW4GXLO34dZt3cXiSYCXM1Li9ZF0NMa-c9M=&xsec_source=pc_search"
								class="social-icon xiaohongshu-icon" aria-label="小红书" target="_blank" rel="noopener noreferrer">
								<div class="qrcode-popup">
									<img :src="require(`@/assets/images/xhs.jpg`)" alt="小红书二维码" style="width:100%; display:block;" />
								</div>
							</a>
						</div>
					</div> -->
				</div>

				<!-- Company Map -->
				<div class="company-map">
					<h2 class="section-title">{{ $t('map.companyLocation') }}</h2>
					<div class="map-container">
						<baidu-map class="map" :center="{ lng: 116.615238, lat: 40.120343 }" :zoom="18">
							<bm-marker :position="{ lng: 116.615238, lat: 40.120343 }" @click="infoWindowOpen = true" />
							<bm-info-window :position="{ lng: 116.615238, lat: 40.120343 }" :title="$t('map.title')"
								:show="infoWindowOpen" @close="infoWindowOpen = false">
							</bm-info-window>
						</baidu-map>

						<div class="map-actions">
							<button class="map-action-btn" @click="openMap">
								<svg viewBox="0 0 24 24" width="16" height="16">
									<path fill="currentColor"
										d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
								</svg>
								{{ $t('map.googleMap') }}
							</button>
							<button class="map-action-btn" @click="openBaiduMap">
								<svg viewBox="0 0 24 24" width="16" height="16">
									<path fill="currentColor"
										d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
								</svg>
								{{ $t('map.baiduMap') }}
							</button>
						</div>
					</div>
				</div>
			</div>

			<!-- Global Offices -->
			<div class="global-offices">
				<h2 class="section-title">{{ $t('contactInfo.globalOffices') }}</h2>

				<div class="office-list">
					<div v-for="office in $t('contactInfo.offices')" :key="office.id" class="office-item"
						:class="{ active: activeOffice === office.id }" @mouseenter="activeOffice = office.id"
						@mouseleave="activeOffice = null" @touchstart="handleOfficeTouch(office.id)">
						<h3>{{ office.city }} <span class="country">{{ $t(`${office.country}`) }}</span></h3>
						<p>
							<svg viewBox="0 0 24 24">
								<path fill="currentColor"
									d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
							</svg>
							{{ office.address }}
						</p>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
	export default {
		name: 'ContactPage',
		data() {
			return {
				showWechatQR: false,
				activeOffice: null,
				isSubmitting: false,
				form: {
					name: "",
					company: "",
					email: "",
					phone: "",
					subject: "",
					message: ""
				},
				touchTimer: null,
				showPopup: false,
				infoWindowOpen: true
			}
		},
		methods: {
			loadBMapScript() {
				return new Promise((resolve, reject) => {
					if (window.BMap) {
						resolve();
						return;
					}

					const script = document.createElement('script');
					script.src = 'https://api.map.baidu.com/api?v=3.0&ak=8oFbUq6B9AZaE2aAbGYVGDGZkR9GIXYz';
					script.onload = () => {
						resolve();
					};
					script.onerror = reject;
					document.head.appendChild(script);
				});
			},
			openMap() {
				window.open("https://maps.app.goo.gl/hyrdyWcNwJRcjMuf9");
			},
			openBaiduMap() {
				window.open("https://map.baidu.com/search/北京泛思特国际运输代理有限公司");
			},
			submitForm() {
				this.isSubmitting = true;
				setTimeout(() => {
					this.isSubmitting = false;
					alert(this.$t('contact.submitSuccess'));
					this.resetForm();
				}, 1500);
			},
			resetForm() {
				this.form = {
					name: "",
					company: "",
					email: "",
					phone: "",
					subject: "",
					message: ""
				};
			},
			handleOfficeTouch(officeId) {
				if (this.touchTimer) clearTimeout(this.touchTimer);
				this.activeOffice = officeId;
				this.touchTimer = setTimeout(() => {
					this.activeOffice = null;
				}, 2000);
			}
		}
	}
</script>

<style scoped>
	/* 新增地图样式 */
	.company-map {
		padding: 1.25rem;
	}

	.map-container {
		background: #fff;
		border-radius: 0.5rem;
		padding: 1.25rem;
		box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.05);
	}

	.map-actions {
		display: flex;
		gap: 0.75rem;
		margin-top: 1rem;
		flex-wrap: wrap;
	}

	.map-action-btn {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		padding: 0.5rem 1rem;
		background: #f8f9fa;
		border: 1px solid #ddd;
		border-radius: 0.25rem;
		color: #3498db;
		font-size: 0.9rem;
		cursor: pointer;
		transition: all 0.2s ease;
	}

	.map-action-btn:hover {
		background: #e9ecef;
		border-color: #ccc;
	}

	.map-action-btn svg {
		flex-shrink: 0;
	}

	/* 保持原有样式不变 */
	.contact-container {
		font-family: system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
		color: #333;
		line-height: 1.6;
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 1rem;
	}

	.main-title {
		font-size: clamp(1.8rem, 4vw, 2.2rem);
		font-weight: 600;
		color: #2c3e50;
		text-align: center;
		margin: 1.5rem 0 2.5rem;
		padding-top: 1rem;
	}

	.section-title {
		font-size: clamp(1.4rem, 3vw, 1.6rem);
		font-weight: 600;
		color: #2c3e50;
		margin-bottom: 1.5rem;
		position: relative;
		padding-bottom: 0.625rem;
	}

	.section-title::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		width: 3.75rem;
		height: 0.1875rem;
		background: #3498db;
	}

	.required {
		color: #e74c3c;
		margin-left: 0.1875rem;
	}

	/* Contact Grid Layout */
	.contact-grid {
		display: grid;
		grid-template-columns: 1fr;
		gap: 2.5rem;
		margin-bottom: 3.75rem;
	}

	@media (min-width: 768px) {
		.contact-grid {
			grid-template-columns: 1fr 1fr;
		}
	}

	/* Contact Info Cards */
	.contact-info {
		padding: 1.25rem;
	}

	.info-card {
		display: flex;
		flex-direction: column;
		margin-bottom: 1.5rem;
		background: #fff;
		border-radius: 0.5rem;
		padding: 1.25rem;
		box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.05);
		transition: transform 0.3s ease, box-shadow 0.3s ease;
	}

	@media (min-width: 480px) {
		.info-card {
			flex-direction: row;
		}
	}

	.info-card:hover {
		transform: translateY(-0.1875rem);
		box-shadow: 0 0.3125rem 0.9375rem rgba(0, 0, 0, 0.1);
	}

	.info-icon {
		flex-shrink: 0;
		margin-bottom: 0.75rem;
		color: #3498db;
		width: 1.5rem;
		height: 1.5rem;
	}

	@media (min-width: 480px) {
		.info-icon {
			margin-right: 1.25rem;
			margin-bottom: 0;
		}
	}

	.info-icon svg {
		width: 100%;
		height: 100%;
	}

	.info-content {
		flex-grow: 1;
	}

	.info-content h3 {
		font-size: 1.2rem;
		margin-bottom: 0.625rem;
		color: #2c3e50;
	}

	.info-content p {
		margin: 0.5rem 0;
		color: #555;
	}

	.info-content a {
		color: #3498db;
		text-decoration: none;
		transition: color 0.2s ease;
	}

	.info-content a:hover {
		color: #2980b9;
		text-decoration: underline;
	}

	.map-link {
		display: inline-block;
		margin-top: 0.625rem;
		padding: 0.375rem 0.75rem;
		background: #f8f9fa;
		border: 1px solid #ddd;
		border-radius: 0.25rem;
		color: #3498db;
		font-size: 0.9rem;
		cursor: pointer;
		transition: all 0.2s ease;
	}

	.map-link:hover {
		background: #e9ecef;
		border-color: #ccc;
	}

	/* Social Media */
	.social-media {
		margin-top: 1.875rem;
		background: #fff;
		border-radius: 0.5rem;
		padding: 1.25rem;
		box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.05);
	}

	.social-media h3 {
		font-size: 1.2rem;
		margin-bottom: 0.9375rem;
		color: #2c3e50;
	}

	.social-icons {
		display: flex;
		gap: 0.9375rem;
	}

	.social-icon {
		width: 2.5rem;
		height: 2.5rem;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;
		transition: all 0.3s ease;
		position: relative;
	}

	.social-icon svg {
		width: 1.25rem;
		height: 1.25rem;
	}

	.social-icon.wechat {
		background: #07C160;
	}

	.social-icon.linkedin {
		background: #0077B5;
	}

	.social-icon.weibo {
		background: #E6162D;
	}

	.social-icon:hover {
		transform: translateY(-0.1875rem);
		box-shadow: 0 0.3125rem 0.625rem rgba(0, 0, 0, 0.2);
	}

	.qr-code-popup {
		position: absolute;
		bottom: 120%;
		left: 50%;
		transform: translateX(-50%);
		background: white;
		padding: 0.9375rem;
		border-radius: 0.5rem;
		box-shadow: 0 0.3125rem 0.9375rem rgba(0, 0, 0, 0.1);
		width: 11.25rem;
		text-align: center;
		z-index: 10;
		display: none;
	}

	.qr-code-popup img {
		width: 100%;
		margin-bottom: 0.625rem;
		border-radius: 0.25rem;
	}

	.qr-code-popup p {
		font-size: 0.8rem;
		color: #666;
		margin: 0;
	}

	.social-icon.wechat:hover .qr-code-popup,
	.social-icon.wechat:focus .qr-code-popup {
		display: block;
	}

	/* Global Offices */
	.global-offices {
		margin-top: 3.75rem;
		padding-bottom: 2.5rem;
	}

	.office-list {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(17.5rem, 1fr));
		gap: 3.25rem;
		margin-top: 1.875rem;
	}

	.office-item {
		background: white;
		padding: 1.25rem;
		border-radius: 0.5rem;
		box-shadow: 0 0.1875rem 0.625rem rgba(0, 0, 0, 0.05);
		transition: all 0.3s ease;
		border-left: 0.1875rem solid transparent;
		cursor: pointer;
	}

	.office-item:hover,
	.office-item.active {
		border-left-color: #3498db;
		box-shadow: 0 0.3125rem 0.9375rem rgba(52, 152, 219, 0.1);
	}

	.office-item h3 {
		font-size: 1.1rem;
		margin-bottom: 0.625rem;
		color: #2c3e50;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	.office-item .country {
		font-size: 0.8rem;
		color: #666;
		font-weight: normal;
		margin-left: 0.5rem;
	}

	.office-item p {
		font-size: 0.9rem;
		margin: 0.625rem 0;
		color: #555;
		display: flex;
		align-items: flex-start;
	}

	.office-item svg {
		margin-right: 0.625rem;
		color: #3498db;
		flex-shrink: 0;
		margin-top: 0.125rem;
		width: 1rem;
		height: 1rem;
	}

	/* Accessibility Improvements */
	a:focus,
	button:focus,
	input:focus,
	select:focus,
	textarea:focus {
		outline: 2px solid #3498db;
		outline-offset: 2px;
	}

	/* Reduced motion for accessibility */
	@media (prefers-reduced-motion: reduce) {
		* {
			animation-duration: 0.01ms !important;
			animation-iteration-count: 1 !important;
			transition-duration: 0.01ms !important;
			scroll-behavior: auto !important;
		}
	}

	.social-media {
		padding: 20px;
		background-color: #fff;
		border-radius: 12px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

		h3 {
			font-size: 20px;
			margin-bottom: 16px;
			color: #333;
		}

		.social-icons {
			display: flex;
			flex-wrap: wrap;
			gap: 9px;
			align-items: center;
		}

		.social-icon-wrapper {
			position: relative;
			display: inline-block;
			height: 40px;

			&:hover {
				.qr-popup {
					opacity: 1;
					visibility: visible;
					transform: translateX(-50%) translateY(0);
				}
			}
		}

		.qr-popup {
			position: absolute;
			bottom: calc(100% + 12px);
			left: 50%;
			transform: translateX(-50%) translateY(10px);
			width: 180px;
			opacity: 0;
			visibility: hidden;
			transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
			z-index: 10;

			&::before {
				content: '';
				position: absolute;
				bottom: -10px;
				left: 50%;
				transform: translateX(-50%);
				border-width: 10px 10px 0;
				border-style: solid;
				border-color: #fff transparent transparent;
			}
		}

		.phone-mockup {
			background: #fff;
			border-radius: 12px;
			box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
			overflow: hidden;
		}

		.phone-screen {
			padding: 15px;
			text-align: center;
		}

		.app-header {
			margin-bottom: 10px;

			.app-icon {
				width: 40px;
				height: 40px;
				margin: 0 auto 5px;
				border-radius: 8px;
				overflow: hidden;

				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}

			.app-name {
				font-size: 14px;
				font-weight: bold;
				color: #333;
			}
		}

		.qr-code {
			width: 120px;
			height: 120px;
			margin: 0 auto 10px;
			padding: 5px;
			background: #fff;
			border: 1px solid #eee;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.hint-text {
			font-size: 12px;
			color: #666;
		}

		.tiktok-icon {
			color: #000;
			background-color: #fff;

			svg {
				width: 24px;
				height: 24px;
			}

			&:hover {
				background-color: #f0f0f0;
			}
		}
	}

	.mini-program-icon {
		width: 32px !important;
		height: 32px !important;
		color: #07C160 !important;
	}

	.social-icon {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 36px;
		height: 36px;
		margin-right: 12px;
		border-radius: 50%;
		overflow: hidden;
		transition: transform 0.3s ease;
	}

	.social-icon:hover {
		transform: scale(1.1);
	}

	.xhs-svg {
		width: 100%;
		height: 100%;
	}


	/* 🌐 响应式优化：移动端垂直堆叠 */
	@media screen and (max-width: 768px) {
		.social-icons {
			flex-direction: column;
			align-items: flex-start;
			gap: 16px;
		}

		.qr-popup {
			width: 160px !important;
			top: 56px !important;
		}
	}

	.map {
		width: 100%;
		height: 360px;
	}
</style>